import { render, staticRenderFns } from "./CardDelivery.vue?vue&type=template&id=ad3a4b34&"
import script from "./CardDelivery.vue?vue&type=script&lang=js&"
export * from "./CardDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports